import { Link } from 'react-router-dom';
import { comics, monthlyRanking } from '@/mocks/comics';

export default function RankingPanel() {
  const list = monthlyRanking
    .map((item) => ({ ...item, comic: comics.find((comic) => comic.id === item.comicId) }))
    .filter((item) => item.comic);

  const rankColor = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-foreground-950';
    if (rank === 2) return 'bg-primary-400 text-foreground-950';
    if (rank === 3) return 'bg-primary-600 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section className="w-full bg-background-100 py-12">
      <div className="mx-auto max-w-[1280px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[320px_1fr]">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-bar-chart-box-line" />
              本月排行
            </span>
            <h2 className="font-heading text-3xl text-foreground-950">抖漫人气月榜</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              基于本月阅读量、追更数与好评度综合计算（演示数据）。榜单每周更新，看看大家都在追什么好漫。
            </p>
            <Link
              to="/list?sort=rank"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              <i className="ri-trophy-line" />
              查看完整榜单
            </Link>
          </div>

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {list.map(({ rank, score, comic }) => (
              <Link
                key={comic!.id}
                to={`/detail/${comic!.id}`}
                className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition hover:border-primary-300"
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sm font-bold ${rankColor(rank)}`}
                >
                  {rank}
                </span>
                <span className="h-14 w-11 shrink-0 overflow-hidden rounded">
                  <img src={comic!.cover} alt={comic!.title} className="h-full w-full object-cover object-top" />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-medium text-foreground-900 transition group-hover:text-primary-600">
                    {comic!.title}
                  </span>
                  <span className="block truncate text-xs text-foreground-500">
                    {comic!.author} · {comic!.region}
                  </span>
                  <span className="mt-0.5 flex items-center gap-1 text-xs text-accent-700">
                    <i className="ri-fire-line" />
                    热度 {score}
                  </span>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}